import { Country } from 'helpers/conf';

type Languages = {
  [codeCountry: string]: {
    name: string;
    locale: Locale;
    countryIcon: string;
    subName?: string;
  }[];
};

export enum Locale {
  ENGLISH = 'en',
  ENGLISH_CANADA = 'en-CA',
  ENGLISH_AUSTRALIA = 'en-AU',
  ENGLISH_NEW_ZEALAND = 'en-NZ',
  FRENCH_CANADA = 'fr-CA',
  FRENCH_SWITZERLAND = 'fr-CH',
  FRENCH = 'fr',
  GERMAN = 'de',
  IRISH = 'en-IE',
  NORWEGIAN = 'no',
  SLOVENIAN = 'sl',
}

export const languages: Languages = {
  [Country.UnitedKingdom]: [
    {
      name: 'World (English)',
      locale: Locale.ENGLISH,
      countryIcon: 'en',
      subName: 'en',
    },
  ],
  [Country.NewZealand]: [
    {
      name: 'New Zealand',
      locale: Locale.ENGLISH_NEW_ZEALAND,
      countryIcon: 'en-NZ',
    },
  ],
  [Country.Australia]: [
    {
      name: 'Australia',
      locale: Locale.ENGLISH_AUSTRALIA,
      countryIcon: 'en-AU',
    },
  ],
  [Country.Canada]: [
    {
      name: 'Canada (English)',
      locale: Locale.ENGLISH_CANADA,
      countryIcon: 'en-CA',
    },
    {
      name: 'Canada (Français)',
      locale: Locale.FRENCH_CANADA,
      countryIcon: 'fr-CA',
      subName: 'fr-CA',
    },
  ],
  [Country.France]: [
    {
      name: 'Swaziland (Français)',
      locale: Locale.FRENCH,
      countryIcon: 'fr-CH',
      subName: 'fr-CH',
    },
  ],
  [Country.Germany]: [
    {
      name: 'Germany',
      locale: Locale.GERMAN,
      countryIcon: 'de',
    },
  ],
  [Country.Ireland]: [
    {
      name: 'Ireland (English)',
      locale: Locale.IRISH,
      countryIcon: 'en-IE',
    },
  ],
};
